/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
(function () {
	const siteNavigation = document.getElementById('site-navigation');

	// Return early if the navigation don't exist.
	if (!siteNavigation) {
		return;
	}

	const button = siteNavigation.querySelector('button.menu-toggle')

	//  Return early if the button don't exist.
	if ('undefined' === typeof button) {
		return;
	}

	button.addEventListener('click', function () {
		document.body.classList.toggle('menu-toggled')
		button.setAttribute('aria-expanded', 'true');

	})

	// Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	document.addEventListener('click', function (event) {
		const isClickInside = siteNavigation.contains(event.target);

		if (!isClickInside) {
			document.body.classList.remove('menu-toggled');
			button.setAttribute('aria-expanded', 'false');
		}
	});

	const subMenuToggle = siteNavigation.querySelectorAll('.sub-menu .menu-item-has-children')

	siteNavigation.addEventListener('mouseleave', function () {
		subMenuToggle.forEach(element => {
			element.classList.remove('expand')
		})
	})
	subMenuToggle.forEach(element => {
		let linkSub = element.querySelector('a')

		linkSub.addEventListener('click', function (event) {
			event.preventDefault()
			element.classList.toggle('expand')
		})
	});

	const menuHasChild = siteNavigation.querySelectorAll('.menu-item-has-children')

	menuHasChild.forEach(element => {
		let linkSub = element.querySelector('a')

		linkSub.addEventListener('touchstart', (event) => {
			event.preventDefault()
			let expanded = document.querySelectorAll('.menu-item-has-children.expand');
			expanded.forEach(el => {
				el.classList.remove('expand')
			})


			element.classList.toggle('expand')
		})
	})

	const nav = document.querySelector('#site-header-top');
	const topOfNav = nav.offsetTop

	if (topOfNav > 32) {
		document.body.classList.add('stick')
	}

	function stickNav() {
		if (window.scrollY >= 32) {
			document.body.classList.add('stick')
		} else {
			document.body.classList.remove('stick')
		}
	}

	window.addEventListener('scroll', stickNav);
    stickNav();
    
    jQuery('.slick').slick();
    
    /**
     * @todo vanilla JS
     */
    if ( jQuery('.trigger-next-row').length ){
        jQuery('.trigger-next-row').on('click touch','.show-next-row',function(){
            jQuery(this).closest('.trigger-next-row').removeClass('hidden').next().removeClass('hidden');
        });
        jQuery('.trigger-next-row').on('click touch','.hide-next-row',function(){
            jQuery(this).closest('.trigger-next-row').addClass('hidden').next().addClass('hidden');
        });
        
        jQuery('.trigger-next-row').append('<a href="javascript:;" class="show-next-row">Voir les détails <span class="icon-arrow-right"></span></a><a href="javascript:;" class="hide-next-row">Fermer les détails <span class="icon-close"></span></a>');
    }

	jQuery('.wp-block-latest-posts__list .wp-block-latest-posts__featured-image').on("click", function() {
		window.location = jQuery(this).parents('li').find("a").attr("href");
	});

	if (jQuery("#gform_fields_2").length) {
		jQuery(".c-accordion__title").each(function() {
			jQuery("#input_2_5").append('<option value="' + jQuery(this).text() + '">' + jQuery(this).html() + '</option>');
		});
	}

	if (jQuery("#billing_country").length) {
		jQuery("#billing_country").find('option[value=""]').html('');
	}

	jQuery(".actions-handle a").on("click", function() {
		jQuery(this).parents(".actions-handle").find(".options").toggleClass("open");
	});
    
}() );

jQuery(window).ready(function () {
    var containerWidth = jQuery(window).width();
    if (containerWidth <= 700) {
        if (jQuery(".fc-listMonth-button").length) {
			jQuery(".fc-listMonth-button").trigger("click");
		}

		if (jQuery(".fc-listYear-button").length) {
			jQuery(".fc-listYear-button").trigger("click");
		}

		jQuery("li.mon-panier, li.mon-compte").on("click", function() {
			window.location = jQuery(this).find("a").attr("href");
		});
    }

	jQuery("#search-presentation-btn").on("click", function() {
		jQuery(this).parents("form").submit();
	});

	jQuery(".mailchimp-formatio").on("click", function(e) {
		e.preventDefault();
		jQuery(".shade").addClass("open");
		jQuery("#newsletter").addClass("open");
	});

	onResize();

	jQuery(window).on('resize', function(){
		var containerWidth = jQuery(window).width();
		if (containerWidth <= 700) {
			if (jQuery(".fc-listMonth-button").length) {
				jQuery(".fc-listMonth-button").trigger("click");
			}

			if (jQuery(".fc-listYear-button").length) {
				jQuery(".fc-listYear-button").trigger("click");
			}
		}

		onResize();

	});

	if (jQuery("body.home .wp-block-latest-posts__list").length) {
		jQuery("body.home .wp-block-latest-posts__list").parents(".wp-block-columns").css("margin-bottom", "0px");
	}

	jQuery("body.not-logged-in").on("click", ".checkout-button", function(e) {
		e.preventDefault();
		jQuery(".shade").addClass("open");
		jQuery(".modal-login").addClass("open");
	});

	jQuery("body.not-logged-in .modal-login .close").on("click", function(e) {
		e.preventDefault();
		jQuery(".shade").removeClass("open");
		jQuery(".modal-login").removeClass("open");
	});
	
	function onResize() {

		// if (jQuery("body.home .hero .diapos").length) {
		// 	console.log(jQuery("body.home .hero .diapos").innerHeight());
		// }


		// if (jQuery('.temoignages .cycle-slideshow').length) {
		// 	if (jQuery('body').outerWidth() < 640) {
		// 		jQuery('.temoignages .cycle-slideshow').attr({'data-cycle-carousel-visible': '1'});
		// 	} else {
		// 		if (jQuery('body').outerWidth() > 640 && jQuery('body').outerWidth() < 1024) {
		// 			jQuery('.temoignages .cycle-slideshow').attr({'data-cycle-carousel-visible': '2'});
		// 		} else {
		// 			jQuery('.temoignages .cycle-slideshow').attr({'data-cycle-carousel-visible': '4'});
		// 		}
		// 	}

		// 	//jQuery('.temoignages .cycle-slideshow').cycle('reinit');
		// }
	}


	updateFormLabels();

	jQuery(".gform_wrapper input, .gform_wrapper textarea, .gform_wrapper select").on("focusin", function() {
		jQuery(this).parents(".gfield").find("> legend").addClass("focus");
		jQuery(this).parents(".gfield").find("> label").addClass("focus");

		jQuery(this).parents(".gfield").find("> legend").removeClass("empty");
		jQuery(this).parents(".gfield").find("> label").removeClass("empty");
	});

	jQuery(".gform_wrapper input, .gform_wrapper textarea, .gform_wrapper select").on("focusout", function() {	
		jQuery(this).parents(".gfield").find("> legend").removeClass("focus");
		jQuery(this).parents(".gfield").find("> label").removeClass("focus");
		updateFormLabels();
	});

	jQuery(".woocommerce-form input.input-text, .woocommerce-form textarea, .woocommerce-form select").on("focusin", function() {
		jQuery(this).parents(".woocommerce-form-row").find("> legend").addClass("focus");
		jQuery(this).parents(".woocommerce-form-row").find("> label").addClass("focus");
	});

	jQuery(".woocommerce-form input.input-text, .woocommerce-form textarea, .woocommerce-form select").on("focusout", function() {
		jQuery(this).parents(".woocommerce-form-row").find("> legend").removeClass("focus");
		jQuery(this).parents(".woocommerce-form-row").find("> label").removeClass("focus");
		updateFormLabels();
	});

	jQuery(".woocommerce-checkout input.input-text, .woocommerce-checkout textarea").on("focusin", function() {
		jQuery(this).parents(".form-row").find("> legend").addClass("focus");
		jQuery(this).parents(".form-row").find("> label").addClass("focus");
	});

	jQuery(".woocommerce-checkout input.input-text, .woocommerce-checkout textarea").on("focusout", function() {
		jQuery(this).parents(".form-row").find("> legend").removeClass("focus");
		jQuery(this).parents(".form-row").find("> label").removeClass("focus");
		updateFormLabels();
	});

	jQuery("#customer_login .login .not-login a.btn").on("click", function() {
    	jQuery("#customer_login").removeClass("login0");
    	jQuery("#customer_login").addClass("login1");
    });

    jQuery("#customer_login .register .is-login a.btn").on("click", function() {
    	jQuery("#customer_login").removeClass("login1");
    	jQuery("#customer_login").addClass("login0");
    });

    jQuery("#field_1_1 legend").on("click", function() {
		jQuery(this).addClass("focus"); 
		jQuery("#input_1_1_6").focus();
    });

    jQuery("#input_1_1_6").on("blur", function() {
    	jQuery("#field_1_1 legend").removeClass("focus");
	});

    jQuery("#field_2_1 legend").on("click", function() {
		jQuery(this).addClass("focus"); 
		jQuery("#input_2_1_6").focus();
    });

    jQuery("#input_2_1_6").on("blur", function() {
    	jQuery("#field_2_1 legend").removeClass("focus");
	});

	jQuery("#reg_optin").parent().find("label").show();


	function updateFormLabels() {
		jQuery(".gform_wrapper input, .gform_wrapper textarea, .gform_wrapper select").each(function() {	
			if (jQuery(this).val().trim() != '' && jQuery(this).val().trim() != '(___) ___-____') {
				jQuery(this).parents(".gfield").find("> legend").addClass("filled");
				jQuery(this).parents(".gfield").find("> label").addClass("filled");
				jQuery(this).parents(".gfield").find("> legend").removeClass("empty");
				jQuery(this).parents(".gfield").find("> label").removeClass("empty");
			} else {
				jQuery(this).parents(".gfield").find("> legend").removeClass("filled");
				jQuery(this).parents(".gfield").find("> label").removeClass("filled");
				jQuery(this).parents(".gfield").find("> legend").addClass("empty");
				jQuery(this).parents(".gfield").find("> label").addClass("empty");
			}
		});

		jQuery(".woocommerce-form input, .woocommerce-form textarea, .woocommerce-form select").each(function() {
			if (jQuery(this).val().trim() != '' && jQuery(this).val().trim() != '(___) ___-____') {
				jQuery(this).parents(".woocommerce-form-row").find("> legend").addClass("filled");
				jQuery(this).parents(".woocommerce-form-row").find("> label").addClass("filled");
				jQuery(this).parents(".woocommerce-form-row").find("> legend").removeClass("empty");
				jQuery(this).parents(".woocommerce-form-row").find("> label").removeClass("empty");
			} else {
				jQuery(this).parents(".woocommerce-form-row").find("> legend").removeClass("filled");
				jQuery(this).parents(".woocommerce-form-row").find("> label").removeClass("filled");
				jQuery(this).parents(".woocommerce-form-row").find("> legend").addClass("empty");
				jQuery(this).parents(".woocommerce-form-row").find("> label").addClass("empty");
			}
		});


		jQuery(".woocommerce-checkout input, .woocommerce-checkout textarea, .woocommerce-checkout select").each(function() {
			if (jQuery(this).val().trim() != '' && jQuery(this).val().trim() != '(___) ___-____') {
				jQuery(this).parents(".form-row").find("> legend").addClass("filled");
				jQuery(this).parents(".form-row").find("> label").addClass("filled");
				jQuery(this).parents(".form-row").find("> legend").removeClass("empty");
				jQuery(this).parents(".form-row").find("> label").removeClass("empty");
			} else {
				jQuery(this).parents(".form-row").find("> legend").removeClass("filled");
				jQuery(this).parents(".form-row").find("> label").removeClass("filled");
				jQuery(this).parents(".form-row").find("> legend").addClass("empty");
				jQuery(this).parents(".form-row").find("> label").addClass("empty");
			}
		});

		jQuery("form label").css("opacity", 1);
	}


	jQuery( document.body ).on( 'updated_checkout', function(){

		jQuery("#payment input").on("focusin", function() {
			jQuery(this).parents(".form-row").find("> label").addClass("focus");
		});
	
		jQuery("#payment input").on("focusout", function() {
			jQuery(this).parents(".form-row").find("> label").removeClass("focus");
			updateFormLabels();
		});

		updateFormLabels();
	
	});

});


